import type { CoinStruct } from '@iota/iota-sdk/client';
import { IotaClient } from '@iota/iota-sdk/client';
import type { WalletAccount } from '@wallet-standard/core';

interface IGetAllCoinsOfTypeParams {
  walletAccount: WalletAccount;
  client: IotaClient;
  coinType: string;
}

export async function getAllCoinsOfType({
  walletAccount,
  client,
  coinType,
}: IGetAllCoinsOfTypeParams) {
  let cursor: string | null | undefined = null;
  let coins: CoinStruct[] = [];

  do {
    // eslint-disable-next-line no-await-in-loop
    const response = await client.getCoins({
      owner: walletAccount.address,
      coinType,
      cursor,
      limit: 50,
    });

    coins = coins.concat(response.data);
    cursor = response.nextCursor;
  } while (cursor);

  return coins;
}
